var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"top-pic clearfix"},_vm._l((_vm.picList),function(item,index){return _c('li',{key:index},[_c('img',{attrs:{"src":item.pic_url}}),_c('p',[_vm._v(_vm._s(item.txt))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }